import { render, staticRenderFns } from "./UsagePolicyPage.vue?vue&type=template&id=ee5e7c6a&"
import script from "./UsagePolicyPage.vue?vue&type=script&lang=js&"
export * from "./UsagePolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports